import type { ThemedDivider } from '@trmediaab/zebra';

const divider: ThemedDivider = {
  common: {
    height: '1px',
  },
  variants: {
    default: {
      bg: 'divider',
    },
  },
};

export default divider;
